import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_CONFIG, API_HEADERS } from "../../../network/config/ApiConfig";
import { USER_API_PATH } from "../../../network/config/apiPaths";
import { useState } from "react";

function AddParticipent() {
    const navigate = useNavigate();

    const [inputvalidation,setInputValidation]=useState({
        name:"",
        phone:"",
        email:"",
        password:""
    })

    const handleChange=(e)=>{
        setInputValidation({
            ...inputvalidation,
            [e.target.name]:e.target.value
        })
    }

    const onSubmit = async () => {
        let requestbody = {
            
            name: inputvalidation.name,
            email: inputvalidation.email,
            phone: inputvalidation.phone,
            role_id: 4,
            password: inputvalidation.password,
            status: "ACTIVE",
            token: "xyz"

        
    }
    let data = await axios.post(API_CONFIG.API_HOST + USER_API_PATH.REGISTRATION_PATH,requestbody, {
            headers: API_HEADERS
        })
    console.log("result of user",data)
    data.status==200&&navigate(-1)
}

return (
    <>
        <div
            style={{
                position: "fixed",
                backgroundColor: "rgba(0,0,0,0.5)",
                width: "100%",
                height: "100%",
                zIndex: "999",
                overflow: "scroll",
            }}
        >
            <div className="d-flex align-item-center justify-content-center">
                <div className="col-md-8">
                    <div className="container">
                        <div className="row mt-2">
                            <div className="col-md-5 card-1 p-5">
                                <h4 className="text-center">Add Participent</h4>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        {/* <label style={labelStyle}>Search City/Town</label>{" "} */}
                                        {/* {inputValidation.place_address} */}
                                        {/* <AutoComplete
                                                    className="form-control"
                                                    style={{ width: "100%" }}
                                                    name="city"
                                                    options={{
                                                        types: ["geocode", "establishment"],
                                                    }}
                                                    onChange={(e) => handleChange(e)}
                                                    value={inputvalidation.city}
                                                    apiKey={"AIzaSyCB14naEHjDiVBFLEqhPBMUA9eqg_4yRdk"}
                                                    onPlaceSelected={(place) => updatePlaceInfo(place)}
                                                    placeholder="Enter city name"
                                                />
     */}
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            onChange={handleChange}
                                            name="name"
                                            value={inputvalidation.name}
                                            className="form-control"

                                        />

                                        <label>Phone number</label>
                                        <input
                                            type="number"
                                            onChange={handleChange}
                                            name="phone"
                                            value={inputvalidation.phone}
                                            className="form-control"

                                        />
                                        <label>Email</label>
                                        <input
                                            type="email"
                                            onChange={handleChange}
                                            name="email"
                                            value={inputvalidation.email}
                                            className="form-control"

                                        />
                                        <label>Category</label>
                                        <select
                                            className="form-control"
                                        >
                                            <option>Devotional Songs</option>
                                            <option>Melody Songs</option>
                                            <option>All type of Songs</option>
                                            <option>Professional Speaker</option>
                                        </select>
                                         <label>Password</label>
                                         <input type="text" 
                                         className="form-control"
                                         name="password" 
                                         value={inputvalidation.password} 
                                         onChange={handleChange} />


                                        {/* {
                                                    item.role_id === "7" ? <>
                                                        <label>Franchise owner</label>
                                                        {
                                                            SelectFranchiseOwner()
                                                        }
                                                    </> : ""
                                                } */}

                                        {/* {item.role_id === "9" ? <>
                                                    <label>Franchise Percentage</label>
                                                    <input
                                                        type="number"
                                                        onChange={handleChange}
                                                        name="foShare"
                                                        value={inputvalidation.foShare}
    
                                                        className="form-control"
    
                                                    />
                                                </> : ""} */}

                                        {/* {
                                                    item.role_id === "9" ?
                                                        <>
                                                            <label>Radius</label>
                                                            <input
                                                                type="number"
                                                                onChange={handleChange}
                                                                name="radius"
                                                                value={inputvalidation.radius}
    
    
                                                                className="form-control"
    
                                                            />
                                                        </> : ""
                                                } */}
                                        {/* <label>Adhar Number</label>
                                                <input
                                                    type="number"
                                                    onChange={handleChange}
                                                    name="adhar"
                                                    value={inputvalidation.adhar}
                                                    className="form-control"
    
                                                />
                                                <label>PAN Number</label>
                                                <input
                                                    type="number"
                                                    onChange={handleChange}
                                                    name="pan"
                                                    value={inputvalidation.pan}
                                                    className="form-control"
    
                                                />
    
                                                <label>Driving License</label>
                                                <input
                                                    type="number"
                                                    onChange={handleChange}
                                                    name="license"
                                                    value={inputvalidation.license}
                                                    className="form-control"
    
                                                /> */}

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                marginTop: 20,
                                            }}
                                        >
                                            <button
                                                style={{ display: "flex", justifyContent: "center" }}
                                                type="button"
                                                className="btn btn-purple-bg"
                                            onClick={onSubmit}
                                            >
                                                Submit
                                            </button>

                                            <button
                                                className="btn btn-white-bg"
                                                onClick={() => {
                                                    // dispatch(
                                                    //   updateFormInfo({
                                                    //     displayForm: false,
                                                    //     formData: {},
                                                    //   })
                                                    // );
                                                    navigate(-1)
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>
);
    

}
export default AddParticipent